import { InjectionToken, Provider, Type } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';
import { ProviderOverride } from './models';

export class OidcConfig {
  public static Configuration(config: {
    securityTokenService: string;
    oidcClientId: string;
    oidcScope: string;
    postLogoutRedirectUri: string;
    isMobileApp?: boolean;
  }): AuthConfig {
    return {
      issuer: config.securityTokenService,
      redirectUri: getBaseUrl() + 'callback',
      clientId: config.oidcClientId,
      responseType: 'code',
      scope: config.oidcScope,
      postLogoutRedirectUri: config.postLogoutRedirectUri,
      sessionChecksEnabled:
        !config.isMobileApp &&
        !(window as any).Cypress &&
        !(window as any).Playwright,
      useSilentRefresh: !config.isMobileApp,
      silentRefreshRedirectUri: getBaseUrl() + 'assets/silent-refresh.html',
      // showDebugInformation: true, // uncomment for debugging authentication issues
      loginUrl: config.securityTokenService + '/connect/authorize',
      tokenEndpoint: config.securityTokenService + '/connect/token',
      userinfoEndpoint: config.securityTokenService + '/connect/userinfo',
      logoutUrl: config.securityTokenService + '/connect/endsession',
      sessionCheckIFrameUrl:
        config.securityTokenService + '/connect/checksession',
      silentRefreshTimeout: 15000,
      customQueryParams: config.isMobileApp
        ? {
            hide_cookie_consent: config.isMobileApp,
          }
        : {},
    };
  }
}

export function getBaseUrl() {
  if (document.getElementsByTagName('base')[0]) {
    return document.getElementsByTagName('base')[0].href;
  }

  return '';
}

export function withDefault<T>(
  token: InjectionToken<T>,
  override: ProviderOverride | undefined,
  defaultClass: Type<T>,
): Provider {
  if (!override) return { provide: token, useClass: defaultClass };
  if (!('provide' in override)) {
    return { ...(override as any), provide: token };
  }
  return override;
}
